import LabelBadge from './LabelBadge'

export { LabelBadge }
